<template lang="html">
  <ul class="list">
    <slot></slot>
  </ul>
</template>

<script>
export default {};
</script>

<style lang="scss">
.list {
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  & > *:not(.divider) {
    position: relative;
    display: block;
    padding: 0.75rem 1.25rem;
    margin-bottom: -1px;
    background-color: #fff;
    border: 1px solid rgba(0, 0, 0, 0.125);

    &.danger {
      color: #721c24;
      background-color: #f5c6cb;
    }
    &.warning {
      color: #856404;
      background-color: #ffeeba;
    }
  }
  &.list-block {
    & > * {
      border-width: 0 0 1px 0;
      margin-bottom: 0;
    }
  }
  &.list-chat {
    & > * {
      border-width: 1px 0;
      padding: 1em 0;
    }
  }
  &.user-profile {
    & > .text {
      display: flex;
      margin-bottom: 5px;
      border-bottom: 1px solid gray(100);
      border-width: 0 0 1px 0;
      padding: 0;
      justify-content: space-between;
      color: gray(700);
      span {
        color: gray(900);
      }
      &:last-child {
        border-bottom: 0;
      }
      & > * {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        display: block;
        max-width: 100%;
      }
      small {
        width: 340px;
        text-align: right;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/parts/components/list.vue